import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Neutrals } from 'src/theme-v2/colors';

export const styles = StyleSheet.create({
  progressWrapper: {
    width: '100%',
    position: 'relative',
    height: 32,
    justifyContent: 'flex-start',
    paddingVertical: 24,
    paddingHorizontal: 0,
  },
  progressBackground: {
    width: '100%',
    height: 7,
    backgroundColor: Neutrals.coldGreys.GreyCold200,
    borderRadius: 5,
    overflow: 'hidden',
  },
  progressFill: {
    height: 7,
    backgroundColor: ColorTypography.TextColorPromo,
    borderRadius: 5,
    // width is animated dynamically
  },
  milestonesContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 20,
    justifyContent: 'center',
  },
});
